/**
 * An error caused by how the CLI was invoked, not by a malfunction (e.g. a
 * slash command that has no headless form passed to `duo run`).
 *
 * The top-level handler prints only the message and exits non-zero, instead
 * of the fatal-crash framing ("unexpected error … report this bug") used for
 * genuine failures — and it is not reported to error tracking.
 */
export class UsageError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UsageError';
  }
}
